/**
 * Static mapping of check name (or hintLabel) → image.
 * When a check is selected in CheckAutocomplete, the image replaces the text label.
 *
 * Keys are matched case-insensitively against:
 *   1. CheckDto.hintLabel (preferred — usually shorter)
 *   2. CheckDto.name (fallback)
 *
 * To add a new mapping:
 *   - Drop the image in `src/core/assets/oot/hints/`
 *   - Import it below and add an entry to CHECK_IMAGES.
 */
import HBA1000 from '@/core/assets/oot/hints/hba1000.png';
import OgcFairy from '@/core/assets/oot/hints/ogc_fairy.png';

export const CHECK_IMAGES: Record<string, string> = {
  // Horseback Archery 1000 points
  'hba 1000': HBA1000,
  'horseback archery 1000': HBA1000,
  // Outside Ganon's Castle great fairy
  'ogc great fairy': OgcFairy,
  'ogc fairy': OgcFairy,
};

/**
 * Look up a static image for a check by hintLabel or name.
 * Returns undefined when no mapping exists.
 */
export function getCheckImage(hintLabel?: string, name?: string): string | undefined {
  const tryKey = (k?: string) => (k ? CHECK_IMAGES[k.toLowerCase()] : undefined);
  return tryKey(hintLabel) ?? tryKey(name);
}
